/** Rota pública (hash router) — destino pós-SSO de vinculação de conta no dispensador. */
export const DISPENSARY_ACCOUNT_LINK_SUCCESS_ROUTE = "/dispensador/conta-vinculada";

function resolveFluxmedAppOrigin(): string {
  const fromEnv = import.meta.env.VITE_ENDPOINT_XDSB_domain as string | undefined;
  if (fromEnv?.trim()) {
    return fromEnv.trim().replace(/\/$/, "");
  }
  if (typeof window !== "undefined" && window.location.origin) {
    return window.location.origin;
  }
  return "https://app.fluxmed.com.br";
}

/** URL absoluta da página de sucesso no domínio Fluxmed (sem auth). */
export function resolveFluxmedAccountLinkSuccessUrl(storeName?: string): string {
  const origin = resolveFluxmedAppOrigin();
  const hashPath = `#${DISPENSARY_ACCOUNT_LINK_SUCCESS_ROUTE}`;
  if (storeName?.trim()) {
    const params = new URLSearchParams({ dispensador: storeName.trim() });
    return `${origin}/${hashPath}?${params.toString()}`;
  }
  return `${origin}/${hashPath}`;
}
